<template>
  <div class="w-100 h-100 d-flex flex-column position-relative">

    <div v-if="!this.$store.state.isShareCodeDraft">
      <div class="row my-2">
        <div class="col">
          <div class="menu-tab-text menu-select-color">データ入稿</div>
        </div>
      </div>

      <div class="row p-2 position-relative" :class="{'feature-ui':this.$store.state.tutorial.isShowPreview && this.$store.state.tutorial.previewStep == 1}">
        <div class="row text-start m-0">
          <p class="m-0 p-0">デザイン（PNG）<img src="@/assets/acrypro/question-icon.svg" style="width:20px;height:20px;margin-left:-5px;margin-top:-5px;" class="cursor-pointer" @click="clickPngHelp()" /></p>
        </div>
        <label class="uploadlabel position-relative"
          ><input
            type="file"
            ref="design"
            accept=".png"
            @change="uploadDesign"
          />
          <div v-if="!isUploadDesign">
            <svg class="fill-color" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <path d="M22.4167 13.0002C22.4167 7.52565 17.9836 3.0835 12.5104 3.0835C7.02583 3.0835 2.58335 7.52663 2.58335 13.0002C2.58335 18.4737 7.02584 22.9168 12.5104 22.9168C17.9836 22.9168 22.4167 18.4747 22.4167 13.0002ZM21.3334 13.0002C21.3334 17.8805 17.3803 21.8335 12.5 21.8335C7.61971 21.8335 3.66669 17.8805 3.66669 13.0002C3.66669 8.11986 7.61971 4.16683 12.5 4.16683C17.3803 4.16683 21.3334 8.11985 21.3334 13.0002Z"/>
            <path d="M7.5 13.8332L17.5 13.8332L17.5 12.1665L7.5 12.1665L7.5 13.8332Z"/>
            <path d="M13.3334 18L13.3334 8L11.6667 8L11.6667 18L13.3334 18Z"/>
            </svg>
            <span class="fw-bold">アップロード</span>
          </div>
          <div v-else>
            <span class="text-main-color">{{this.getDesignFileName()}}</span>
          </div>
        </label>
      </div>

      <div class="row p-2 position-relative" :class="{'feature-ui':this.$store.state.tutorial.isShowPreview && this.$store.state.tutorial.previewStep == 2}">
        <div class="row text-start m-0">
          <p class="m-0 p-0">カットライン（SVG）<img src="@/assets/acrypro/question-icon.svg" style="width:20px;height:20px;margin-left:-5px;margin-top:-5px;" class="cursor-pointer" @click="clickSvgHelp()" /></p>
        </div>
        <label class="uploadlabel position-relative"
          ><input
            type="file"
            ref="cutline"
            accept=".svg"
            @change="uploadCutline"
          />
          <div v-if="!isUploadCutline">
            <svg class="fill-color" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <path d="M22.4167 13.0002C22.4167 7.52565 17.9836 3.0835 12.5104 3.0835C7.02583 3.0835 2.58335 7.52663 2.58335 13.0002C2.58335 18.4737 7.02584 22.9168 12.5104 22.9168C17.9836 22.9168 22.4167 18.4747 22.4167 13.0002ZM21.3334 13.0002C21.3334 17.8805 17.3803 21.8335 12.5 21.8335C7.61971 21.8335 3.66669 17.8805 3.66669 13.0002C3.66669 8.11986 7.61971 4.16683 12.5 4.16683C17.3803 4.16683 21.3334 8.11985 21.3334 13.0002Z"/>
            <path d="M7.5 13.8332L17.5 13.8332L17.5 12.1665L7.5 12.1665L7.5 13.8332Z"/>
            <path d="M13.3334 18L13.3334 8L11.6667 8L11.6667 18L13.3334 18Z"/>
            </svg>
            <span class="fw-bold">アップロード</span>
          </div>
          <div v-else>
            <span class="text-main-color">{{this.getCutlineFileName()}}</span>
          </div>
        </label>
      </div>

      <hr class="mt-1 mb-0">
    </div>

    <div class="row my-1">
      <div class="col m-0">
        <div class="menu-tab-text menu-select-color m-0">個数・金額</div>
      </div>
    </div>



    <!-- 境界線 -->

    <p class="m-1 text-start" style="font-size: 15px;">金額</p>
    <p class="fw-bold m-1 text-end mb-0" style="">{{totalPrice}}円</p>
    <hr class="m-0">

    <p class="m-1 text-start" style="font-size: 15px;">( 1枚単価 <span class="status-error-color">{{discountText}}</span> )</p>
    <p class="fw-bold m-1 text-end mb-0" style="">{{price}}円</p>
    <hr class="m-0">

    <p class="m-1 text-start" style="font-size: 15px;">数量</p>
    <div class="m-1 mb-2 text-end d-flex justify-content-end form" style="">
      <input type="number" min="1" max="1000" v-model="acrylNum" @blur="numBlur" class="forminput text-end no-spin pe-2" />
    </div>
    <hr class="m-0">

    <div class="mt-auto w-100 my-3 position-relative" :class="{'disable-ui':!(isUploadDesign&&isUploadCutline) && !this.$store.state.tutorial.isShowPreview}">
      <div class="position-relative" :class="{'feature-ui':this.$store.state.tutorial.isShowPreview && this.$store.state.tutorial.previewStep == 3}">
        <button @click="clickEdit" class="acry-btn-secondary-normal btn-size my-2 text-nowrap" >テキスト・二次元コードを入れる</button>
      </div>
      <div>
        <button @click="clickCart" class="acry-btn-cartin btn-size my-1" >カートに入れる</button>
      </div>

      <!-- チュートリアル用3 -->
      <TutorialModal
        :visible="$store.state.tutorial.isShowPreview && $store.state.tutorial.previewStep == 3"
        title="テキスト・二次元コードを入れる"
        arrowTop="142px"
        style="height:185px; bottom:72px; right: 320px;"
        @close="tutorialNextStep()">
        <p class="text-start">登録されたPNGとSVGデータを元に一部テキスト・二次元コードを入れることができます。</p>
      </TutorialModal>
    </div>

    <!-- チュートリアル用1 -->
    <TutorialModal
      :visible="$store.state.tutorial.isShowPreview && $store.state.tutorial.previewStep == 1"
      title="デザイン入稿（PNG）"
      arrowTop="40px"
      style="height:242px; top:60px; right: 320px;"
      @close="tutorialNextStep()">
      <p class="text-start">作成されたPNGデータをアップロードします</p>
      <p class="text-start m-0">アップロードするとキャンバスにプレビュー表示されます。</p>
      <p class="text-start">プレビューでズレが発生する場合サイズが間違っている可能性がありますのでデータを確認ください。</p>
    </TutorialModal>

    <!-- チュートリアル用2 -->
    <TutorialModal
      :visible="$store.state.tutorial.isShowPreview && $store.state.tutorial.previewStep == 2"
      title="カットライン入稿（SVG）"
      arrowTop="40px"
      style="height:242px; top:159px; right: 320px;"
      @close="tutorialNextStep()">
      <p class="text-start">作成されたSVGデータをアップロードします</p>
      <p class="text-start m-0">アップロードするとキャンバスにプレビュー表示されます。</p>
      <p class="text-start">パス情報をカットラインとして作成されますのでPNGデータと位置が合っているかご確認ください。</p>
    </TutorialModal>
  </div>
</template>

<script>
import {
  CenterViewState,
  RightViewState,
  GetAcryProductPrice,
  GetAcryProductSizeText,
} from "@/js/Const.js";
import {  DiscountRatio, CombineSVGFrame, TrimmingDesignImageFile, ConvertSvgToPng, CreateFrameCutlineImage } from "@/js/CommonFunc.js";
// import { OffScreen } from "@/js/OffScreen.js";
import { ProductData } from "@/js/ProductData.js";
import VueCookies from "vue-cookies";
import { Big } from 'big.js';
import { Analytics } from "@/js/Analytics.js";
import TutorialModal from "@/components/acyrpro/modal/TutorialModal.vue";

export default {
  name: "RightMenuPreview_Ap",
  props: {},
  data: function () {
    return {
      designFileName:"デザインデータ",
      cutlineFileName:"カットラインデータ",
      acrylNum: 10,
      price: 0,       // 割引後の1枚あたりの金額
      discountText: "",
      totalPrice: 0,  // 合計金額（税別）
      frameCutlineImageURL: null,
    };
  },
  watch: {
  },
  computed: {
    isUploadDesign() {
      return this.$store.state.designImageURL != null;
    },
    isUploadCutline() {
      return (this.$store.state.scCutlineImageFile != null) || (this.$store.state.cutlineImageFile != null);
    },
  },
  async created() {
    this.$store.commit("setIsFirstTutorial", false);

    // 販売中のプロダクト情報を取得
    this.$store.commit("showRightMenu");
    this.$store.commit("showLoading");
    await this.$store.state.saleProductManager.update().catch((e) => {
      this.$handleError("018", e, { hideLoading: true });
      this.$store.commit("hideLoading");
      return;
    });

    if (
      this.$store.state.saleProductManager.getProduct(
        this.$store.state.selectProductId
      ) == null
    ) {
      this.$store.commit("hideLoading");
      this.$store.commit("showMessage", "現在販売されていない商品です");
      this.$store.commit("setCenterViewState", CenterViewState.Upload);
      return;
    }

    this.selectProductData = this.$store.state.saleProductManager.getProduct(
      this.$store.state.selectProductId
    );

    this.updatePriceText();

    // シェアコード入稿の場合はここでカートプレビュー用画像を作っておく
    if (this.$store.state.scCutlineImageURL) {
      // カートプレビュー用
      const blob = await CreateFrameCutlineImage(this.$store.state.scCutlineImageURL);
      this.frameCutlineImageURL = URL.createObjectURL(blob)
    }

    this.$store.commit("hideLoading");

    if( this.$store.state.isShareCodeDraft ){
      // シェアコード入稿
      // SVGチュートリアルをすでに見ている場合は無視
      let isTutorial = VueCookies.get("t_sp") || VueCookies.get("t_p");
      if( !isTutorial ){
        this.$store.commit("setIsFirstTutorial", true);

        VueCookies.set("t_sp", true, '1y');

        // チュートリアル開始
        this.$store.commit("showPreviewTutorial", 3);
      }
    }else{
      // SVG入稿
      let isTutorial = VueCookies.get("t_p");
      if( !isTutorial ){
        this.$store.commit("setIsFirstTutorial", true);

        VueCookies.set("t_p", true, '1y');

        // チュートリアル開始
        this.$store.commit("showPreviewTutorial");
      }
    }

  },
  components: { TutorialModal },
  methods: {
    numBlur(){
      if( isNaN(this.acrylNum) ) this.acrylNum = 1;
      if( this.acrylNum < 1 ) this.acrylNum = 1;
      if( this.acrylNum > 1000 ) this.acrylNum = 1000;
      this.updatePriceText();
    },
    getDesignFileName(){
      return this.designFileName;
    },
    getCutlineFileName(){
      return this.cutlineFileName;
    },
    async uploadDesign() {
      let file = this.$refs.design.files[0];
      this.designFileName = file.name;

      file = await TrimmingDesignImageFile(file, this.$store.state.selectProductId);
      const blob = new Blob([file], { type: file.type });

      this.$store.commit("setDesignImageFile", blob);
      this.$store.commit("setDesignImageURL", URL.createObjectURL(blob));

      // プレビュー用に画像を設定
      this.$store.commit('designPreview/set', { key: 'designImageURL', value: this.$store.state.designImageURL })
    },
    async uploadCutline() {
      let file = this.$refs.cutline.files[0];

      // // 画像の輪郭を抽出

      // フレームパスを合成
      file = await CombineSVGFrame(file, this.selectProductData.productId);

      this.cutlineFileName = file.name;
      this.$store.commit("setCutlineImageFile", file);
      this.$store.commit("setCutlineImageURL", URL.createObjectURL(file));

      // SVGをPNGに変換
      let fileUrl = await ConvertSvgToPng(this.$store.state.cutlineImageURL, this.selectProductData.productId);
      this.$store.commit('designPreview/set', { key: 'cutlineImagePngURL', value: fileUrl });

      // カートプレビュー用
      const blob = await CreateFrameCutlineImage(fileUrl);
      this.frameCutlineImageURL = URL.createObjectURL(blob)
    },
    updatePriceText(){
      // 数量変更される
      if( this.acrylNum == 0 ){
        this.totalPrice = this.price = 0;
        this.discountText = "";
      }else{
        let productPrice = GetAcryProductPrice(this.selectProductData.productId);
        let productTotal = parseInt(this.acrylNum) + parseInt(this.$store.state.cartManager.getCartProductQuantity(this.selectProductData.productId));
        let ratio = DiscountRatio(productTotal);

        if( ratio == 0 ){
          this.discountText = "";
        }else{
          this.discountText = ratio + "%割引適応";
        }

        // 丸め誤差が出ないようにライブラリを使用して計算
        let priceBaseTotal = new Big(this.acrylNum * productPrice.priceBase); // 税抜き価格の合計
        let priceRatio = new Big(100-ratio).div(100);
        let totalPrice = priceBaseTotal.times(priceRatio);
        this.totalPrice = Math.floor(totalPrice.toNumber());
        this.price = Math.floor(this.totalPrice / this.acrylNum);
      }
    },
    async clickEdit() {
      if (!(this.isUploadDesign && this.isUploadCutline)) {
        this.$store.commit("showMessage", "入稿されていないデータがあります");
        return;
      }

      if (this.acrylNum < 1) {
        this.$store.commit("showMessage", "1枚以上にしてください");
        return;
      }

      this.$store.commit("showCartInDialog", this.editProcess);
    },

    async editProcess(){
      this.$store.commit("showLoading");
      await this.createProduct();
      // 開始時に空白のテキストを追加しておく
      // this.$store.state.currentCanvasData.addTextItem(
      //   Array.from({ length: this.acrylNum }, () => ""),
      //   "AnitoStd-M",
      //   "center",
      //   "#000000",
      //   "TextItem_1"
      // );
      // this.$store.state.currentCanvasData.addQRItem(
      //   Array.from({ length: this.acrylNum }, () => ""),
      //   "#000000",
      //   "#FFFFFF",
      //   "CodeItem_1"
      // );

      this.$store.commit("hideLoading");
      this.$store.commit("setCenterViewState", CenterViewState.Edit);
      this.$store.commit("setRightViewState", RightViewState.Edit);
    },

    async clickCart() {
      if (!(this.isUploadDesign && this.isUploadCutline)) {
        this.$store.commit("showMessage", "入稿されていないデータがあります");
        return;
      }

      if (this.acrylNum < 1) {
        this.$store.commit("showMessage", "1枚以上にしてください");
        return;
      }

      // プログレスバーを表示
      this.$store.commit("showProgress");
      this.$store.commit("setProgressMessages", [
        "デザインデータを作成中…",
        "しばらくお待ちください",
      ]);

      // プロダクトタイプが再編集になっている場合はカートの中のものを削除
      if (this.$store.state.currentProduct && this.$store.state.currentProduct.cartId != "") {
        await this.$store.state.cartManager
          .delete(this.$store.state.currentProduct.cartId)
          .catch((e) => {
            this.$handleError("019", e, { hideProgress: true });
            return;
          });
      }

      await this.createProduct();
      this.$store.commit("setProgress", 5);

      await this.$store.state.draftManager
        .registDesign(this.$store.state.currentProduct, false, this.$store)
        .catch((e) => {
          this.$handleError("020", e, { hideProgress: true });
          return;
        });
      this.$store.commit("setProgress", 15);

      let self = this;
      await this.$store.state.cartManager.addCartProduct(this.$store.state.currentProduct, true, function(progress){
        self.$store.commit("setProgress", 15 + (85 / 100 * progress));
      })
        .catch((e) => {
          this.$handleError("021", e, { hideProgress: true });
          return;
        });

      // 割引後の単価を計算
      const productPrice = GetAcryProductPrice(this.selectProductData.productId);
      const totalQuantity = parseInt(this.$store.state.cartManager.getCartProductQuantity(this.selectProductData.productId));
      const ratio = DiscountRatio(totalQuantity);
      // 丸め誤差が出ないようにライブラリを使用して計算
      const priceBase = new Big(productPrice.priceBase);
      const priceRatio = new Big(100-ratio).div(100);
      const discountPrice = priceBase.times(priceRatio);

      const productSizeTxt = GetAcryProductSizeText(this.selectProductData.productId);
      Analytics.addToCartAcrylic(this.$store.state.currentProduct.productId, this.$store.state.currentProduct.productName, this.$store.state.currentProduct.quantity, discountPrice.toNumber(), productSizeTxt, true );

      this.$store.commit("hideProgress");
      this.$store.commit("showMessage", "カートに追加しました");

      // 表示を戻す
      this.$store.commit("setCenterViewState", CenterViewState.Upload);
      this.$store.commit("setRightViewState", RightViewState.Cart);
    },

    async createProduct() {
      let p = new ProductData(
        this.selectProductData,
        this.selectProductData.productData["product_class_list2"][0]
      );

      p.quantity = this.acrylNum;
      p.setPrintInfo("front");
      p.tagTemplateName = "";
      p.isShareCodeDraft = this.$store.state.isShareCodeDraft;

      this.$store.commit("addProduct", p);
      this.$store.commit("selectCanvasData", p.canvasDatas[0]);

      await this.$store.state.currentCanvasData.setBaseImage(
        this.$store.state.designImageFile,
        this.$store.state.designImageURL,
        (this.$store.state.isShareCodeDraft)?this.$store.state.scCutlineImageFile:this.$store.state.cutlineImageFile,
        this.frameCutlineImageURL
      );
    },

    tutorialNextStep(){
      if( this.$store.state.tutorial.isFirst ){
        // 初回は強制で全て表示
        if(this.$store.state.tutorial.previewStep == 3){
          this.$store.commit("hidePreviewTutorial");
          this.$store.commit("setIsFirstTutorial", false);
        }else{
          this.$store.commit("previewTutorialNextStep");
        }
      }else{
        // 2回目以降は一部分のみ表示
          this.$store.commit("hidePreviewTutorial");
      }
    },
    clickPngHelp(){
      this.$store.commit("showPreviewTutorial", 1);
    },
    clickSvgHelp(){
      this.$store.commit("showPreviewTutorial", 2);
    },

  },
};
</script>

<style scoped lang="scss">
.uploadlabel {
  margin: 8px;
  padding: 8px;
  cursor: pointer;
  font-size: 15px;
  width: 267px;
  height: 40px;
  color: $primary-main-color;
  border: 2px solid $primary-main-color;
  border-radius: 100px;
  background: $background-white-color;
}

.fill-color {
  fill: $primary-main-color;
  position: absolute;
  left: 51px;
  top: 6px;
}

input[type="file"] {
  display: none;
}

.btn-size{
  width: 100%;
  height: 40px;
  font-weight: bold;
}
.form{
  height: 48px;

}

.forminput {
  width: 100%;
  border: 1px solid $status-success-color;
}

.disable-ui {
  opacity: 0.5;
}

.feature-ui{
  z-index: 3;
  pointer-events: none;
  background: white;
}

</style>
